import { render, staticRenderFns } from "./appDocForm.vue?vue&type=template&id=52e27b7f"
import script from "./appDocForm.vue?vue&type=script&lang=js"
export * from "./appDocForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports